import React from "react";
import { graphql } from 'gatsby';

import Layout from "../components/layout";
import SEO from "../components/seo";

const ContactPage = ({ pageContext, data }) => {
    return (
        <Layout {...pageContext} showContact={false}>
            <SEO
                lang={pageContext.lang}
                path={pageContext.pageUrl}
                title={data.seoTitleText}
                description={data.seoDescriptionText}
                />
            <div id="header">
                <div className="section-content">
                    <div className="big-text">
                        {data.contactTitle ? (<h2 className="t-left f-large normal">{data.contactTitle}</h2>) : null}
                        <div className="separator-small"></div>
                        {data.contactSubtitle ? (<h3 className="t-left f-medium normal" dangerouslySetInnerHTML={{ __html: data.contactSubtitle }} />) : null}
                        <br />
                        {data.contactTextEmail ? (<h3 className="t-left f-normal normal link-underline" dangerouslySetInnerHTML={{ __html: data.contactTextEmail }} />) : null}
                        {data.contactTextPhone ? (<h3 className="t-left f-normal normal link-underline" dangerouslySetInnerHTML={{ __html: data.contactTextPhone }} />) : null}
                        {data.contactTextWhatsapp ? (<h3 className="t-left f-normal normal link-underline" dangerouslySetInnerHTML={{ __html: data.contactTextWhatsapp }} />) : null}
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default ContactPage

export const pageQuery = graphql`
    query ContactPage($lang: String!) {
        seoTitleText: getTranslation(lang: $lang, key: "contact_seo_title")
        seoDescriptionText: getTranslation(lang: $lang, key: "contact_seo_description")

        contactTitle: getTranslation(lang: $lang, key: "contact_title")
        contactSubtitle: getTranslation(lang: $lang, key: "contact_subtitle", html: true, removeWrapper: true)
        contactTextEmail: getTranslation(lang: $lang, key: "contact_text_email")
        contactTextPhone: getTranslation(lang: $lang, key: "contact_text_phone")
        contactTextWhatsapp: getTranslation(lang: $lang, key: "contact_text_whatsapp")
    }
`
